import IntlTelInput from "intl-tel-input/reactWithUtils";
import "intl-tel-input/styles"
import { useRef, useState } from "react";
import { formatMbWayNumber } from "../../common/Helper";
import ToastAlert from "../../common/ToastAlert";

const MbWay = ({ sendMbwayPaymentRequest }) => {
    const inputRef = useRef(null);
    const [phone, setPhone] = useState("");
    const [phoneError, setPhoneError] = useState("");
    const [countryCode, setCountryCode] = useState("");
    const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);

    const checkboxChangeHandler = () => {
        if(!isCheckboxChecked){
            setIsCheckboxChecked(!isCheckboxChecked)
        }
    }


    const handleNumberChange = (e) => {
        setPhone(e)
        const instance = inputRef?.current?.getInstance();
        let countryData = instance?.getSelectedCountryData();
        setCountryCode(countryData?.dialCode)
    };

    const handleValidityChange = (isValid) => {
        if (phone) {
            if (!isValid) {
                setPhoneError('Invalid phone number')
            } else {
                setPhoneError('')

            }
        }
    };

    const handleClickContinue = () => {
        if (!isCheckboxChecked) {
            ToastAlert({ msg: "Please check terms & condition", msgType: "error" });
            return false;
        }
        if (phone && countryCode) {
            let mbwayFormatedNum = formatMbWayNumber(countryCode, phone)
            sendMbwayPaymentRequest(mbwayFormatedNum)
        } else {
            ToastAlert({ msg: "Phone Number is Required", msgType: "error" });
            return false;
        }

    }



    return (
        <div className="registerBox">
            <div className="onlyText">
                <p>Easy and simple payment using “MB WAY” on your mobile phone. (Only available for customers of Portuguese banks with MB WAY app installed - Payment service provided by IfthenPay)</p>
            </div>
            <div className="form-group my-4">
                <label for="">Your phone number linked to MB WAY </label>
                {/* <input className="commonInputSecond" type="text" placeholder="Creative Uzbeks" /> */}
                <IntlTelInput
                    ref={inputRef}
                    // initialValue={phone}
                    onChangeNumber={(e) => handleNumberChange(e)}
                    onChangeValidity={(e) => handleValidityChange(e)}
                    // formatOnDisplay={false}
                    showFlags={true}
                    initOptions={{
                        initialCountry: 'pt',
                        separateDialCode: true,
                    }}

                />
                {phoneError && phoneError && <span className="cus-err mt-1" style={{ position: "relative" }}>{phoneError}</span>}

            </div>
            <div className="checkAndGo">
            <div className="tandcMainDiv">
                        <div className="clickTo" onClick={() => checkboxChangeHandler()}>
                            <input type="checkbox"
                                checked={isCheckboxChecked}
                                disabled={isCheckboxChecked}
                                className="keyword-checkbox" />

                            <label htmlFor="" className="keyword-label" style={{ cursor: "pointer" }}>I have read and agree to the website </label>
                        </div>
                        <a target="_blank" className="tandcLink" href="/terms-and-conditions"> terms and conditions</a>
                    </div>
            </div>
            <div className="continueBox">
                <button className="btn continueBtn" onClick={() => handleClickContinue()}>Continue <i className="fa-solid fa-circle-arrow-right"></i></button>
            </div>
        </div>
    )

}
export default MbWay